import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import LoadingIndicator from '@sorare/core/src/atoms/loader/LoadingIndicator';
import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import MatchView from '@sorare/gameplay/src/components/MatchView';

import { PlayerDetailsDrawer } from 'components/player/PlayerDetailsDrawer';

import {
  RivalsLineupsQuery,
  RivalsLineupsQueryVariables,
} from './__generated__/index.graphql';

const RIVALS_LINEUPS_QUERY = gql`
  query RivalsLineupsQuery($slug: String!) {
    football {
      rivals {
        id
        game(slug: $slug) {
          id
          slug
          game {
            id
          }
        }
      }
    }
  }
` as TypedDocumentNode<RivalsLineupsQuery, RivalsLineupsQueryVariables>;

const Root = styled(Vertical)`
  padding: var(--double-unit);
`;

type Props = { rivalsGameSlug: string; showUpsell?: boolean };

export const Lineups = ({ rivalsGameSlug, showUpsell }: Props) => {
  const { up: isLaptop } = useScreenSize('laptop');
  const [playerData, setPlayerData] = useState<{
    playerSlug: string;
    scoreId?: string;
  }>();
  const { data, loading } = useQuery(RIVALS_LINEUPS_QUERY, {
    variables: { slug: rivalsGameSlug },
  });

  if (loading) {
    return <LoadingIndicator small />;
  }

  const { game: rivalsGame } = data?.football.rivals || {};
  if (!rivalsGame) {
    return null;
  }

  const { game } = rivalsGame;

  return (
    <Root>
      <MatchView
        desktop={isLaptop}
        id={game.id}
        hideScoresAndGameWeek
        onPlayerSelect={(playerSlug, scoreId) =>
          setPlayerData({ playerSlug, scoreId })
        }
      />
      <PlayerDetailsDrawer
        open={!!playerData}
        playerSlug={playerData?.playerSlug}
        scoreId={playerData?.scoreId}
        onClose={() => {
          setPlayerData(undefined);
        }}
        showUpsell={showUpsell}
      />
    </Root>
  );
};
